import React, { useEffect, useState } from 'react'
import {
  CAvatar,
  CButton,
  // CButtonGroup,
  CCard,
  CBadge,
  CCardBody,
  // CCardImage,
  CCardTitle,
  CCardText,
  //  CCardFooter,
  //  CCardHeader,
  CCol,
  CImage,
} from '@coreui/react'
import { cilArrowCircleLeft } from '@coreui/icons'
import CIcon from '@coreui/icons-react'
import apiClient from '../../services/apiClient'
import { useNavigate } from 'react-router-dom'
import { AI_ASSISTANT_IMAGE, buildApiUrl } from '../../utils/getConfiguration'

const AIAdvices = () => {
  const [recommendations, setRecommendations] = useState([])

  const fetchRecommendationsData = async () => {
    try {
      const response = await apiClient.get(
        buildApiUrl('aiAdvices', {
          account_ID: localStorage.getItem('account_ID'),
        }),
      )
      setRecommendations(response.data)
    } catch (error) {
      console.error('Error fetching recommendations', error)
    }
  }

  useEffect(() => {
    fetchRecommendationsData()
  }, [])

  let navigate = useNavigate()
  console.log('Weather trigger is TRUE and ' + localStorage.getItem('weather_trigger'))

  return (
    <>
      <CCard className="mb-4">
        <CCardBody>
          <CCol sm={12}>
            <h4 id="traffic" className="card-title mb-0">
              A.I.Advices
              <hr></hr>
            </h4>
          </CCol>
          <CCol sm={12}>
            <CButton
              color="primary"
              onClick={() => {
                //localStorage.removeItem('loginName1')
                //localStorage.removeItem('wizard')
                console.log('Back')
                navigate('/dashboard')
              }}
            >
              <CIcon icon={cilArrowCircleLeft} size="xxl" />
            </CButton>
          </CCol>
        </CCardBody>
      </CCard>
      <CCard className="mb-4">
        <CCardBody>
          <CCol sm={12}>
            <div className="small text-medium-emphasis">
              <CCardText className="alert alert-danger">
                System is currently learning A.I. brain to gather decision logic for: weather
                triggers, behaviorals,season activities, age driven activities, gender,
                obsolescence, future, device, learning, patterns, sensors
              </CCardText>
              {recommendations.length > 0 && (
                <div>
                  {recommendations.map((recommendation) => (
                    <div key={recommendation.aiadvice_ID} className="mb-4">
                      {/*{recommendation.reminder_ID === localStorage.getItem('taskid') && (*/}
                      <div key={recommendation.aiadvice_ID}>
                        {localStorage.getItem('weather_trigger') === 'true' && (
                          <div>
                            <CCard sm={2} className="mb-4">
                              <CCardBody>
                                <CCardTitle>
                                  <CImage
                                    rounded
                                    orientation="top"
                                    src={recommendation.pic}
                                    width={50}
                                    height={50}
                                    onClick={() => {
                                      //console.log('Task Detail ' + recommendation.reminder_ID)
                                      //localStorage.setItem('taskid', recommendation.reminder_ID)
                                      //navigate('/risks')
                                    }}
                                  />
                                  {recommendation.Prio === '1' && (
                                    <CBadge color="danger" className="ms-2">
                                      HIGH RISK
                                    </CBadge>
                                  )}
                                  {recommendation.Prio === '2' && (
                                    <CBadge color="warning" className="ms-2">
                                      WARNING
                                    </CBadge>
                                  )}
                                  {recommendation.Prio === '3' && (
                                    <CBadge color="info" className="ms-2">
                                      INFO
                                    </CBadge>
                                  )}
                                </CCardTitle>
                              </CCardBody>
                            </CCard>
                            <h5 id="traffic" className="card-title mb-0">
                              <p id="caption 2">{recommendation.Title}</p>
                            </h5>
                            <hr />
                            <h5 id="traffic" className="card-title mb-0">
                              <CAvatar src={AI_ASSISTANT_IMAGE} size="md" />
                              <p id="caption 2">A.I. Recommendation:</p>
                            </h5>
                            <p id="caption 3">
                              - This task should be realized in {recommendation.duedate}. month.
                            </p>
                            <p id="caption 4">- {recommendation.AI1}</p>
                            <hr></hr>
                            <div className="d-grid gap-2 d-md-flex justify-content-md-end">
                              <p id="caption 6">A.I.Proposed month:</p>
                              <CButton
                                color="info"
                                onClick={() => {
                                  if (Number(localStorage.getItem('AImonth')) < 12) {
                                    localStorage.setItem(
                                      'AImonth',
                                      Number(localStorage.getItem('AImonth')) + 1,
                                    )
                                    console.log('Month PLUS ' + localStorage.getItem('AImonth'))
                                    //handleClickPostpone()
                                  }
                                }}
                              >
                                +
                              </CButton>
                              <CCardText>{recommendation.expecteddate}</CCardText>
                              <CButton
                                color="info"
                                onClick={() => {
                                  if (Number(localStorage.getItem('AImonth')) > 1) {
                                    localStorage.setItem(
                                      'AImonth',
                                      Number(localStorage.getItem('AImonth')) - 1,
                                    )
                                    console.log('Month MINUS ' + localStorage.getItem('AImonth'))
                                    //handleClickPostpone()
                                  }
                                }}
                              >
                                -
                              </CButton>
                              <CButton
                                color="info"
                                onClick={() => {
                                  console.log('Month Reset')
                                  localStorage.setItem('AImonth', recommendation.duedate)
                                  //handleClickPostpone()
                                }}
                              >
                                Reset
                              </CButton>
                            </div>
                            <hr></hr>
                            <div className="d-grid gap-2 d-md-flex justify-content-md-end">
                              Actions:
                              <CButton
                                color="info"
                                onClick={() => {
                                  //localStorage.removeItem('loginName1')
                                  //localStorage.removeItem('wizard')
                                  localStorage.setItem('taskid', recommendation.reminder_ID)
                                  console.log('Postponed reminder ' + recommendation.reminder_ID)
                                  //handleClickPostpone()
                                  navigate('/dashboard')
                                }}
                              >
                                Re-plan
                              </CButton>
                            </div>
                          </div>
                        )}
                      </div>
                      {/* )} */}
                    </div>
                  ))}
                </div>
              )}
            </div>
          </CCol>
        </CCardBody>
      </CCard>
      <CCard
      // key={recommendation.reminder_ID}
      // style={{ width: '12rem', height: '25rem' }}
      >
        <CCardBody>
          <CCol sm={12}>
            <CButton
              color="primary"
              onClick={() => {
                //localStorage.removeItem('loginName1')
                //localStorage.removeItem('wizard')
                console.log('Back')
                navigate('/dashboard')
              }}
            >
              <CIcon icon={cilArrowCircleLeft} size="xxl" />
            </CButton>
          </CCol>
        </CCardBody>
      </CCard>
    </>
  )
}

export default AIAdvices
